export class LogoModel {
  constructor(public efrr: string, public efrrWcag: string, public fePopc: string, public fePopcWcag: string){};
}
